import { InternalError } from './parsers/error';


export default function parseUrl(url) {
  // possible formats:
  // https://www.facebook.com/thisisinsiderdesign/videos/384893281852307/?hc_ref=NEWSFEED
  // https://www.facebook.com/thisisinsiderdesign/videos/vb.228803477461289/384893281852307/?type=2&theater
  // https://www.facebook.com/video.php?v=1790717287849662

  url = decodeURIComponent(url);

  let matched = url.match(/\.facebook\.com\/[^/]+\/videos\/(?:[^/]+\/)?(\d+)\/?/);

  if (!matched) {
    matched = url.match(/\.facebook\.com\/video\.php\?v=(\d+)/);
  }

  if (!matched) {
    return Promise.reject(new InternalError(400, 'wpm_error.malformed_external_link', 'External link was not formatted properly'));
  }

  return Promise.resolve(matched[1]);
}



// WEBPACK FOOTER //
// ./src/transport/adapters/facebook/parse-url.js